import React from 'react';
import { theme } from '../../../../core/theme/theme';

const Attribution = () => {
    return (
        <div
            style={{
                position: 'absolute',
                paddingLeft: 3,
                paddingRight: 3,
                bottom: 0,
                right: 0,
                zIndex: 400,
                backgroundColor: theme.colors.default,
                fontStyle: 'italic',
                opacity: 0.7,
            }}
        >
            <span>powered by</span>{' '}
            <a className="aTag" href="https://layermap.org" target="_blank" style={{ background: 'white !important' }}>
                layermap.org
            </a>
        </div>
    );
};

export default Attribution;
